// useForm.js
import { useState, useEffect } from 'react';
import { getPreviousDivWiseLedgerDetails } from '../../Service/ApiService';
import { useNavigate, useLocation } from 'react-router-dom';
import { getDashboardRouteForUser } from 'utils/menuConfig';

const LedgerPreviousDivWiseDetailsController = (initialState, validate) => {
  const [formData, setFormData] = useState(initialState);
  const [ledgerData, setLedgerData] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const user = JSON.parse(localStorage.getItem('user'));
  const storedLedgerData = JSON.parse(localStorage.getItem('previousDivWiseLedgerData'));
  const navigate = useNavigate();
  const location = useLocation();
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const { profitCenter } = location.state || {};

  // useEffect(() => {
  //   if (storedLedgerData && storedLedgerData.partyCode) {
  //     fetchLedgerDetailsData();
  //   }
  // }, []);

  useEffect(() => {
    fetchLedgerDetailsData();
  }, []);

  const handleInputChange = (inputValue) => {
   // setSearchText(inputValue);
  };

  const handleViewClick = () => {
    navigate(getDashboardRouteForUser());
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
     // fetchLedgerData(formData.customer.value); // Use the new function
    }
  };

  const fetchLedgerDetailsData = async () => {
    try {
      
      setcLoading(true);
let convertical=confvalue.confvertical;
      const response = await getPreviousDivWiseLedgerDetails(
        storedLedgerData.partyCode,
        storedLedgerData.month,
        storedLedgerData.year,
        storedLedgerData.opening,
        convertical,
        profitCenter,
        user.isSFA
      );

      setLedgerData([]);
      if (response && response.success === 'true') {
        setLedgerData(response.data);
      } else {
        setLedgerData([]);
      }
      setcLoading(false);
    } catch (error) {
      console.error('Error fetching ledger data:', error);
      setcLoading(false);
    }
  };

  const handleCustomerChange = (e) => {
    if (e) {
      setFormData({
        ...formData,
        ['customer']: e // Update formData with the selected customer
      });

      setErrors({
        ...errors,
        ['customer']: '' // Clear any existing errors
      });
    } else {
      setFormData({
        ...formData,
        ['customer']: null // Clear the customer field in formData
      });

      setErrors({
        ...errors,
        ['customer']: '' // You can set a validation error or reset it
      });

      setLedgerData([]);
    }
  };

  return {
    ledgerData,
    formData,
    user,
    cloading,
    errors,
    handleCustomerChange,
    handleSubmit,
    handleInputChange,
    handleViewClick
  };
};

export default LedgerPreviousDivWiseDetailsController;
